import GlobalDrawer from './GlobalDrawer.vue';

const GlobalDrawerPlugin = {
    install(Vue) {
        Vue.prototype.$drawer = {
            show(options) {
                const GlobalDrawerComponent = Vue.extend(GlobalDrawer);
                const instance = new GlobalDrawerComponent();
                instance.$slots.default = [options.content];
                // 弹窗标题
                instance.title = options.title;
                // 弹窗的开启与关闭
                instance.visible = options.visible;
                // 弹窗的宽度大小
                instance.size = options.size;
                // 弹窗关闭前的回调
                instance.beforeClose = options.beforeClose;
                // 弹窗打开方向
                instance.direction = options.direction;
                instance.$mount();
                document.body.appendChild(instance.$el);
            }
        };

        Vue.component('GlobalDrawer', GlobalDrawer);
    }
};

export default GlobalDrawerPlugin;